import { useTranslations } from "use-intl";
import { AppleSignInButton } from "./apple-sign-in-button";
import { authFeatures } from "./auth-features";
import { GoogleSignInButton } from "./google-sign-in-button";

/**
 * The social sign-in buttons and the "Or continue with" divider that separates
 * them from the email form below.
 *
 * Each button also hides itself when its provider is unconfigured, so with
 * neither configured the block and its divider would frame an empty gap —
 * render nothing at all instead. Returns a fragment so both halves stay direct
 * children of the page's `space-y-*` stack.
 */
export function SocialSignIn({
  onError,
}: {
  onError?: (error: string) => void;
}) {
  const t = useTranslations("auth.socialSignIn");
  const { appleSignInEnabled, googleSignInEnabled } = authFeatures;
  if (!(appleSignInEnabled || googleSignInEnabled)) {
    return null;
  }

  return (
    <>
      <div className="flex flex-col gap-3">
        <GoogleSignInButton onError={onError} />
        <AppleSignInButton onError={onError} />
      </div>

      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t border-muted-foreground/25" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-background px-2 text-muted-foreground">
            {t("divider")}
          </span>
        </div>
      </div>
    </>
  );
}
